<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <v-btn @click="showSearch = true" color="primary" depressed
          ><v-icon>search</v-icon> {{ $t('search') }}</v-btn
        >
      </div>
      <v-data-table
        expand
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="data"
        class="elevation-1 scgallrenttable"
      >
        <template v-slot:items="props">
          <tr @click="showItemDetail(props.item)" style="cursor: pointer">
            <!-- <td>
              <v-chip small dark :color="memberColor(props.item.membertype)">
                {{ memberLabel(props.item.membertype) }}
              </v-chip>
            </td> -->
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.phone_number }}</td>
            <td>{{ props.item.card_no ? props.item.card_no : '-' }}</td>
            <td>{{ props.item.address }}</td>
            <td>{{ props.item.postcode ? props.item.postcode : '-' }}</td>
            <td>{{ props.item.dob | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.member_register | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.member_expired | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.receipt_no }}</td>
            <td>{{ props.item.points }}</td>
            <td>
              <template v-for="(item, i) in onSplitTag(props.item.tags)">
                <v-chip small dark color="primary" :key="i">
                  {{ item }}
                </v-chip>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="showSearch" width="650px" persistent>
        <v-card>
          <member-filter @onsearch="onSearch" @close="showSearch = false"></member-filter>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDetail" width="650px" persistent>
        <v-card>
          <member-detail
            v-if="showDetail"
            :userid="detail.userid"
            :card_id="detail.card_id"
            @close="showDetail = false"
          ></member-detail>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import MemberFilter from './MemberFilter.vue'
import MemberDetail from './MemberDetail.vue'
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  components: {
    MemberFilter,
    MemberDetail
  },
  data() {
    return {
      detail: {},
      showDetail: false,
      showSearch: false,
      loading: false,
      data: [],
      filter: {
        status: '',
        registerdate_from: '',
        registerdate_to: '',
        expireddate_from: '',
        expireddate_to: '',
        brand: ''
      },
      headers: [
        // { text: 'Membership type', value: 'type' },
        { text: 'Name', value: 'first_name' },
        { text: 'Email', value: 'email' },
        { text: 'Phone number', value: 'phone' },
        { text: 'ID Card', value: 'card_no' },
        { text: 'Address', value: 'address' },
        { text: 'Postcode', value: 'postcode' },
        { text: 'Birthday', value: 'birthday' },
        { text: 'Register Date', value: 'register date' },
        { text: 'Expired Date', value: 'expired date' },
        { text: 'Receipt No.', value: 'receipt no' },
        { text: 'Points', value: 'point' },
        { text: 'Tag', value: 'tags' }
      ],
      tags: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getgpkmemberdashboard()
  },
  methods: {
    showItemDetail(item) {
      this.detail = {
        userid: item.userid,
        card_id: item.card_id
      }
      this.showDetail = true
    },
    memberColor(item) {
      if (item == 'sharemembership') {
        return 'orange'
      } else {
        return 'blue'
      }
    },
    memberLabel(item) {
      if (item == 'sharemembership') {
        return 'Share'
      } else {
        return 'Basic'
      }
    },
    onSearch(payload) {
      this.showSearch = false
      this.getgpkmemberdashboard(payload)
    },
    getgpkmemberdashboard(filter = {}) {
      var vm = this
      vm.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        ...filter
      }
      api.postgpkmemberdashboard(data, (err, response) => {
        vm.loading = false
        if (response.responsecode == 200) {
          if (response.data) {
            vm.data = response.data
          }
        }
      })
    },
    onSplitTag(tags) {
      return tags.split(',')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/grampablokof/Member.vue